import React from 'react';
import { theme } from '../../../../ui';
import { useSettingsObject } from '../../../settings/hooks';
import { getLighterThemeColor, getUserThemeColor } from '../../../../ui/theme/colors';
import OverviewCard from '../OverviewCard';

const TeacherOverviewWidget = ({ stats, coursesCount = 0 }) => {
  const settings = useSettingsObject();
  const userTheme = settings?.theme;
  const brandColor = userTheme?.color ? getUserThemeColor(userTheme?.color) : theme.colors.PRIMARY;

  const overviewStats = [
    {
      label: 'COURSES',
      value: coursesCount,
      icon: 'Course',
      color: brandColor,
      bgColor: getLighterThemeColor(brandColor),
    },
    {
      label: 'STUDENTS',
      value: stats.totalStudents,
      icon: 'Users',
      color: theme.colors.PRIMARY,
      bgColor: theme.colors.PRIMARY_LIGHT,
    },
    {
      label: 'REVIEWS',
      value: stats.pendingEvaluations,
      icon: 'Task',
      color: stats.pendingEvaluations > 0 ? theme.colors.SECONDARY : theme.colors.SUCCESS_GREEN,
      bgColor: stats.pendingEvaluations > 0 ? theme.colors.SECONDARY_LIGHT : theme.colors.SUCCESS_LIGHT,
      labelColor: stats.pendingEvaluations > 0 ? theme.colors.SECONDARY : undefined,
    },
    {
      label: 'COMPLETION',
      value: `${stats.completionRate}%`,
      icon: 'TrendingUp',
      color: theme.colors.SUCCESS_GREEN,
      bgColor: theme.colors.SUCCESS_LIGHT,
    },
  ];

  return <OverviewCard title='Teaching Overview' stats={overviewStats} />;
};

export default TeacherOverviewWidget;
